import { QueryKey } from '@shared/config';
import { useInfiniteRequest } from '@shared/config/query/hooks';
import { keepPreviousData } from '@tanstack/react-query';
import type { CandidateProposedVacancy, GetVacanciesRequest } from '../types';
import { vacancyApi } from '../vacancyApi';

type UseGetCandidateVacanciesParams = GetVacanciesRequest & {
  enabled?: boolean;
};

export const useGetCandidateVacancies = (
  candidateId: string | undefined,
  params: UseGetCandidateVacanciesParams
) => {
  const { enabled = true, ...requestParams } = params;

  return useInfiniteRequest<CandidateProposedVacancy>({
    queryKey: [QueryKey.GET_CANDIDATE_VACANCIES, requestParams, candidateId],
    queryFn: ({ pageParam }) =>
      vacancyApi.getCandidateVacancies(candidateId!, {
        ...requestParams,
        ...pageParam,
      }),
    initialPageParam: {
      perPage: requestParams.perPage,
      page: requestParams.page,
    },
    placeholderData: keepPreviousData,
    enabled: Boolean(candidateId) && enabled,
  });
};
